export const SECONDS_OUT = 0.3;
export const SECONDS_IN = 0.7;
export const flyoutTransitionIn = {
    duration: SECONDS_IN,
    type: 'tween',
    ease: [0.5, 0, 0, 1],
    precision: 0.01,
};
export const flyoutTransitionOut = {
    duration: SECONDS_OUT,
    type: 'tween',
    ease: [0.5, 0, 0, 1],
    precision: 0.01,
};
export const containerVariants = {
    initial: {
        x: '100%',
        transition: Object.assign({}, flyoutTransitionOut),
    },
    open: {
        x: 0,
        transition: Object.assign({}, flyoutTransitionIn),
    },
    closed: {
        x: '100%',
        transition: Object.assign({}, flyoutTransitionOut),
    },
};
export const homeMenuVariants = (open) => {
    return {
        animate: {
            x: 0,
            transition: open ? Object.assign({}, flyoutTransitionOut) : Object.assign({}, flyoutTransitionIn),
        },
        exit: {
            x: '-100%',
            transition: Object.assign({}, flyoutTransitionOut),
        },
    };
};
export const subMenuVariants = (open) => {
    return {
        animate: {
            x: 0,
            transition: Object.assign({}, flyoutTransitionOut),
        },
        exit: open
            ? {
                x: '100%',
                transition: Object.assign({}, flyoutTransitionOut),
            }
            : {},
    };
};
//# sourceMappingURL=config.js.map